import {useState, useEffect} from 'react';

// borrowed from https://usehooks.com/useWindowSize/
// credit: ui.dev

export default function useWindowSize() {
    // This app is client-only (no SSR), so read the real size on the very
    // first render instead of starting undefined — avoids a layout jump
    // once the resize effect fires after mount.
    const [windowSize, setWindowSize] = useState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
    useEffect(() => {
      function handleResize() {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
  }